
import { leagueTaskStore, userToolStore } from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import ShowPopup from '@/components/ShowPopup.vue';
import Create from './Create.vue';

@Component({
  components: { ShowPopup, Create },
})
export default class ListLeagueRoundTask extends Vue {
  public leagueRoundId: string | undefined;
  public leagueTaskId: number = 0;
  public search = '';

  public headersLeagueRoundTask = [
    {
      text: 'Nome',
      sortable: true,
      value: 'name',
      align: 'left',
    },
    {
      text: 'Descrição',
      sortable: true,
      value: 'description',
      align: 'left',
      type: 'varchar',
    },
    {
      text: 'Pontuação',
      sortable: true,
      value: 'score',
      align: 'left',
      type: 'varchar',
    },
    {
      text: 'Desafio?',
      sortable: true,
      value: 'is_challenge',
      align: 'left',
      type: 'boolean',
    },
    {
      text: 'Início',
      sortable: true,
      value: 'period_start',
      align: 'left',
      type: 'varchar',
    },
    {
      text: 'Fim',
      sortable: true,
      value: 'period_end',
      align: 'left',
      type: 'varchar',
    },
    {
      text: 'Ações',
      value: 'actions',
    },
  ];

  get selectedLeagueTask() {
    return this.leagueTaskId;
  }

  get tasks() {
    return leagueTaskStore.leagueTasks;
  }

  get userTool() {
    return userToolStore.currentUserTools.find((t) => t.tool_id === 47);
  }

  public async handleEditTask(payload: { id: number }) {
    this.leagueTaskId = payload.id;

    const form = this.$refs.showLeagueTask as any;
    form.show();
  }

  public async handleNewTask() {
    this.leagueTaskId = 0;
    const form = this.$refs.showLeagueTask as any;
    form.show();
  }

  public async handleDeleteLeagueRoundTask(payload: { id: number }) {
    this.$swal({
      title: 'Confirma a exclusão da Tarefa?',
      text: 'Após a exclusão a mesma não poderá ser recuperada',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, eu confirmo!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        await leagueTaskStore.deleteLeagueTask({ id: payload.id });
      }
    });
  }

  public async mounted() {
    this.leagueRoundId = this.$route.params.leagueRoundId;

    if (!this.leagueRoundId) return;

    await leagueTaskStore.getTasksByRound({ roundId: this.leagueRoundId });
  }
}
